import { render } from "./AddOverrideView.vue?vue&type=template&id=67d79ee5&scoped=true&lang=pug"
import script from "./AddOverrideView.vue?vue&type=script&lang=js"
export * from "./AddOverrideView.vue?vue&type=script&lang=js"

import "./AddOverrideView.vue?vue&type=style&index=0&id=67d79ee5&scoped=true&lang=scss"

import exportComponent from "/builds/wiwdata/applications/finance-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67d79ee5"]])

export default __exports__